var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    "data-name": "Group 1160",
    transform: "translate(12613 13985)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 24,
    height: 24,
    transform: "translate(-12613 -13985)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1160-2",
    "data-name": "Group 1160",
    transform: "translate(-2.069 -2.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-right",
    d: "M0,16.018,6.593,9.425a2.008,2.008,0,0,0,0-2.831L0,0",
    transform: "translate(-12590.923 -13967.179) rotate(90)",
    fill: "none",
    stroke: "#303763",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-right-2",
    "data-name": "arrow-right",
    d: "M0,0,6.593,6.593a2.008,2.008,0,0,1,0,2.831L0,16.018",
    transform: "translate(-12606.939 -13973.485) rotate(-90)",
    fill: "none",
    stroke: "#303763",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaps);
export default __webpack_public_path__ + "static/media/collaps.e7c35dd55dac49463512cc1ec88d3792.svg";
export { ForwardRef as ReactComponent };